<!--
 * @Author: 金小瑞
 * @Date: 2018-07-24 08:51:44
 * @LastEditors: 金小瑞
 * @LastEditTime: 2019-08-29 21:43:38
 -->
<template>
  <transition name="light-fade">
    <div
      class="lightbox"
      :class="customClass"
      v-show="visible"
      @click.self="close">
      <div class="lb-box" v-loading="loading" :style="style">
        <transition name="img-fade">
          <img ref="lb-img" :src="url" class="lb-image" v-show="!loading">
        </transition>
      </div>
      <div class="el-icon-close" @click="close"></div>
    </div>
  </transition>
</template>

<script>
  import Clickoutside from 'element-ui/lib/utils/clickoutside'

  export default {
    data () {
      return {
        url: '',
        style: {
          width: '60%',
          height: '70%'
        },
        visible: false,
        customClass: '',
        onClose: null,
        showClose: false,
        closed: false,
        loading: true
      }
    },
    watch: {
      closed (newVal) {
        if (newVal) {
          this.visible = false
          this.$el.addEventListener('transitionend', this.destroyElement)
        }
      }
    },
    methods: {
      destroyElement () {
        this.$el.removeEventListener('transitionend', this.destroyElement)
        this.$destroy(true)
        this.$el.parentNode.removeChild(this.$el)
      },
      close () {
        this.closed = true
        if (typeof this.onClose === 'function') {
          this.onClose(this)
        }
      },
      // 初始化图片
      initImg (img) {
        const Width = window.innerWidth
        const Height = window.innerHeight
        // 如果图片的宽大于窗口的80%或高大于窗口的90%时，进行压缩处理
        if (img.width > Width * 0.8 || img.height > Height * 0.9) {
          if (Width / Height > img.width / img.height) {
            this.$nextTick(() => {
              const scale = Height * 0.8 / img.height
              this.style.height = Height * 0.8 + 'px'
              this.style.width = img.width * scale + 'px'
              this.loading = false
            })
          } else {
            this.$nextTick(() => {
              const scale = Width * 0.8 / img.width
              this.style.width = Width * 0.8 + 'px'
              this.style.height = img.height * scale + 'px'
              this.loading = false
            })
          }
        } else {
          this.$nextTick(() => {
            this.style.width = img.width + 'px'
            this.style.height = img.height + 'px'
            this.loading = false
          })
        }
      }
    },
    directives: { Clickoutside },
    mounted () {
      this.visible = true
      const img = this.$refs['lb-img']
      const that = this
      const timer = window.setInterval(function () {
        if (img.complete) {
          that.initImg(img)
          clearInterval(timer)
        }
      }, 10)
    }
  }
</script>

<style lang="less" scoped>

  .lightbox {
    position: fixed;
    width: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    transition: opacity 0.5s;
    overflow: hidden;
    z-index: 10000;
    .lb-box {
      position: absolute;
      transform: translate(-50%, -50%);
      left: 50%;
      top: 50%;
      background-color: #fff;
      box-sizing: border-box;
      box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
      transition: all 0.6s ease-out;
      .lb-image {
        border-radius: 3px;
        border: 4px solid #fff;
        display: block;
        width: 100%;
        max-height: none;
        opacity: 1;
        transition: opacity 0.2s ease 0.5s;
      }
      .img-fade-enter, .img-fade-leave-active {
          opacity: 0;
      }
    }
    .el-icon-close {
      position: absolute;
      font-size: 32px;
      color: #CCC;
      right: 25px;
      top: 25px;
      font-weight: 200;
      cursor: pointer;
    }
  }
</style>


// WEBPACK FOOTER //
// main.vue?5bc32fbe